export default __webpack_public_path__ + "static/media/Ruhul_Amin_Sujon_Laravel_Developer.e8eedb43.pdf";